<template>
  <div>
    <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
      <h2 class="mt-n2 mb-4 text-center">Please sign in</h2>
      <v-form ref="theForm" @submit.prevent="loginClick">
        <v-text-field 
          v-model="email"
          outlined dense hide-details="auto"
          label="Email"
          placeholder=" " persistent-placeholder
          autocapitalize="none"
          :rules="[ required] "
          validate-on-blur
        />

        <v-text-field
          v-model="password"
          :type="pw_visible ? 'text' : 'password'"
          outlined dense class="mt-6"
          label="Password"
          placeholder=" " persistent-placeholder
          :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="pw_visible = !pw_visible"
        />
        <div class="d-flex justify-center">
          <v-btn width="60%" type="submit" color="primary">login</v-btn>
        </div>
        <div class="ml-3 mt-3 text-center">
          <router-link :to="{ name: 'recover' }">
            Forgot your password?
          </router-link>
        </div>
      </v-form>
    </div>
    <ErrorOverlay title="Login Error" v-model="error_dialog" :loading="loading">
      {{ error_message }}
    </ErrorOverlay>
  </div>
</template>
<script>

import { mapActions, mapMutations } from 'vuex'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'
import { required } from '@/lib/validations'

export default {
  name: 'Login',

  mixins: [ ErrorOverlayMixin ],

  data: () => ({
    email: '',
    password: '',
    pw_visible: false,

    // validations
    required,
  }),

  computed: {
    needsSpace() {
      return this.$refs.emailField?.validationState != 'error'
    },
  },

  methods: {
    ...mapActions('auth', ['login']),
    ...mapMutations('auth', { setAcceptanceKeys: 'SET_ACCEPTANCE_KEYS' }),

    async loginClick() {
      if (this.$refs.theForm.validate()) {
        let { email: id } = this
        const result = await this.login({ id, password: this.password })
        console.log({ login: result })
        if (result.ok) {
          this.$router.push({ name: 'referrals' })
        } else if (result.status == 403 && result.code == 1) {
          this.setAcceptanceKeys(result)
          this.$router.push({ name: 'login/accept' })
        } else if (result.status == 403 && result.code == 2) {
          this.error_dialog = true
          this.error_message = "Your account has been deactivated."
        } else {
          this.error_dialog = true
          this.error_message = "That username and password don't match, please try again."
        }
      }
    },
  },
}
</script>